DOMReady( function(){
  const smoothScroll = (element, time, callback) => {
      if (time == null) {
          time = 500;
      }

      let delta = 1000 / 30;
      let timeElapsed = 0;

      let from = window.scrollY;
      let to = element.getBoundingClientRect().top + from;

      if( document.getElementById( 'header' ) ){
        to = to - document.getElementById( 'header' ).offsetHeight; // down to #header height
      }

      if( window.innerWidth < 992   && document.getElementById('mobile-megaban')){
        to = to - (document.getElementById('mobile-megaban').offsetHeight);
      }

      to = to - 80;// minus 20 to be a little before anchor
      let interval = setInterval(() => {
          let progress = timeElapsed / time;
          let y = (progress * to) + ((1 - progress) * from);
          window.scrollTo(0, y);

          timeElapsed += delta;

          if (timeElapsed >= time) {
              window.scrollTo(0, to);
              window.clearInterval(interval);
              if (typeof callback === 'function') {
                  callback();
              }
          }
      }, delta);
  }

  const smoothscrollLinks = document.querySelectorAll('a[href^="#"]:not([href="#"], [data-scrollto]');
  smoothscrollLinks.forEach((smoothscrollLink) => {
    let anchorID = false;
    if( smoothscrollLink.dataset.scrollto ){
       anchorID = smoothscrollLink.dataset.scrollto;
    }
    else if( smoothscrollLink.hash ) {
        anchorID = smoothscrollLink.hash;
    }
    if( anchorID ){
      anchorID = anchorID.replace(/^(#|(=.*))/g, '');
      if( document.getElementById( anchorID ) ){
        smoothscrollLink.addEventListener('click', (e)=>{
          e.preventDefault();
          smoothScroll( document.getElementById( anchorID ) );
        });
      }

    }
  });

  // Au document ready, si l'url contient un hash, on lance l'animate vers cet id, avec un decallage de la hauteur du #header + 50px
  let anchorID = window.location.hash;
  if( anchorID ){
    anchorID = anchorID.replace(/^(#|(=.*))/g, '');
    if( document.getElementById( anchorID ) ){
      smoothScroll( document.getElementById( anchorID ) );
    }
  }
});
